import React from "react";

const CustomTextarea = ({
  field,
  name,
  form,
  labelText,
  ...props
}) => {
  const getFieldClasses = (touched, errors) => {
    const classes = ["form-control"];
    if (touched &&  errors) {
      classes.push("is-invalid");
    }

    if (touched && !errors) {
      classes.push("is-valid");
    }
    return classes.join(" ");
  };
  return (
    <div>
      <label htmlFor={field.name} className="mb-1">{labelText}</label>
      <textarea
        {...field}
        {...props}
        className={`
          ${getFieldClasses(form?.touched?.[field.name], form?.errors?.[field.name])} `}
      />
      {/* {touched[field.name] && errors[field.name] && (
        <div className="invalid-feedback">{errors[field.name]}</div>
      )} */}
    </div>
  );
};

export default CustomTextarea;
